import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from '@mui/material'
import { Box } from '@mui/system';
import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { delimiters } from '../../constants/delimiters';
import { treeActions } from '../../redux/slices/treeSlice';
import hexToAscii from '../../utils/utilFunctions';
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import { eachDeep } from "deepdash-es/standalone";
import { cloneDeep } from 'lodash';
import { newTemplateActions } from '../../redux/slices/newTemplateSlice';

function DelimiterDialog(props) {
  const parentScreen = useContext(ParentScreenCtx);
  const { modalOpen, close, val, from } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [delimInput, setDelimInput] = useState('');
  const rightTree = useSelector(state => state.treeData[state.treeData.currentScreen]?.rightTree);
  const selectedNode = rightTree?.tree[rightTree?.currentTab]?.selectedNode;
  const translatedData = rightTree?.tree[rightTree?.currentTab]?.translatedData;
  const { DelimitedHeaderData } = useSelector(state => state.newTemplate)
  const quickAdd = useSelector(state => state?.treeData[state.treeData.currentScreen]?.quickAdd);
  const dataValidationDelim = useSelector(state => state.treeData[state.treeData.currentScreen]?.dataValidationDelim);

  const columns = [
    { id: 'select', label: t('COL_SELECT'), minWidth: 75 },
    { id: 'description', label: t('DESCRIPTION'), minWidth: 100 },
    { id: 'hex', label: t('HEX'), minWidth: 75 },
  ];

  const handleChange = (key, value) => {
    if (key === 'EOD_TERMINATOR') return encodeURIComponent(value);
    if (key) {
        const encodedValue = encodeURIComponent(value);
        dispatch(treeActions.setRightTreeTemplateHeaders({ screen: parentScreen, key, value: encodedValue }));
    }
  }
  const handleItemChange = (key, value) => {

    if (key === 'EOD_TERMINATOR' || key === 'SET_INDEXTYPE') return encodeURIComponent(value);
    if (key === 'DATA_TERMINATOR') return;
    if (key === 'RECORD_DELIMITER' || key === 'FIELD_DELIMITER') {
      const encodedValue = encodeURIComponent(value)
      dispatch(newTemplateActions.setDelimitedHeaderData({ ...DelimitedHeaderData, [key]: encodedValue }))
    }
    if (key === 'recordDelim' || key === 'fieldDelim') {
      const encodedValue = encodeURIComponent(value)
      dispatch(
        treeActions.setQuickAdd({
          data: { ...quickAdd, [key]: encodedValue },
        })
      );
    } else if(key === 'dataValiadtionRecordDelim' || key === 'dataValiadtionFieldDelim'){
      const encodedValue = encodeURIComponent(value);
      dispatch(
        treeActions.setDataValidationDelim({
          data: {...dataValidationDelim, [key]: encodedValue}
        })
      )
    }
    else {
      const updatedData = eachDeep(cloneDeep(translatedData), (obj) => {
        if (obj?.key === selectedNode?.key) {

          if (key === 'DELIMITER') {
            obj[key] = value;
          }
          dispatch(treeActions.setRightTreeSelectedNode({
            screen: parentScreen,
            type: rightTree?.currentTab,
            data: obj
          }));
        }
      });
      dispatch(
        treeActions.setNewRightTreeTranslatedData({
          screen: parentScreen,
          type: rightTree.currentTab,
          data: updatedData,
        })
      );
    }

  }
  const handleModalAction = (save) => {
    if (save && !from) {
      // Template Properties: Convert CR/LF/CRLF to actual characters, then URL encode
      // This matches Java SWT behavior where delimiters are stored as %0D%0A in JSON
      const TEMPLATE_PROPERTY_KEYS = [
        'LINEDELIMITER',
        'DELIMITER', 
        'GROUP_SEPARATOR',
        'REPETITION_DELIMITER',
        'ESCAPE_CHARACTER',
        'SUBCOMPONENT_DELIMITER',
        'VAL_BEGIN_DELIMITER',
        'VAL_END_DELIMITER'
      ];
      
      let valueToSave = delimInput;
      
      // Only apply conversion and encoding for template delimiter keys
      if (TEMPLATE_PROPERTY_KEYS.includes(props.name)) {
        // Convert CRLF/CR/LF to actual characters (matching Java DelimiterDialog.java line 364-365)
        valueToSave = delimInput
          .replaceAll('CRLF', '\r\n')
          .replaceAll('CR', '\r')
          .replaceAll('LF', '\n');
        
      }
      
      handleChange(props.name, valueToSave);
    }
    else if (save && from) {
      handleItemChange(props.name, delimInput)
    }
    close();
  }

  const handleAddButton = (hex) => {
    const input = delimInput + (hex === '0A' ? 'LF' : hex === '0D' ? 'CR' :  hexToAscii(hex));
    setDelimInput(input)
  }

  const handleTextField = (e) => {
    setDelimInput(e.target.value);
  }

  const handleClear = () => {
    setDelimInput('')
  }

  const handleCRLF = (val) => {
    setDelimInput(val)
  }

  const padNumber = (num) => {
    const stringNumber = num.toString();
    return stringNumber.length === 1 ? '0' + num : num;
  }
  const removeASCIIValues = (input) => {
    // First handle ASCII format like "ASCII 65 (A)"
    const regex = /ASCII (\d+) \(([^)]+)\)/g;
    const matches = input.match(regex);
    let result = input;
    
    if (matches) {
      result = '';
      matches.forEach((match) => {
        const asciiCode = match.match(/\d+/);
        const character = String.fromCharCode(parseInt(asciiCode, 10));
        result += character;
      });
    }
    
    // Then handle actual CR/LF characters and convert them back to CRLF string for display
    const crChar = hexToAscii('0D'); // Carriage Return
    const lfChar = hexToAscii('0A'); // Line Feed
    
    // Check if input contains both CR and LF characters in sequence
    if (result.includes(crChar + lfChar)) {
      result = result.replaceAll(crChar + lfChar, 'CRLF');
    } else {
      // Handle individual CR and LF characters
      result = result.replaceAll(crChar, 'CR').replaceAll(lfChar, 'LF');
    }
    
    return result;
  };
  useEffect(() => {
    if (val) setDelimInput(removeASCIIValues(val));
  }, [modalOpen])

  return (
    <>
      <Dialog maxWidth={'sm'} open={modalOpen} onClose={close}>
        <DialogTitle className="dialog-header">
          <div className="title">{t('DIAG_DELIMITER_TIT')}</div>
          <div className="description">{t('DIAG_DELIMITER_DESC')}</div>
        </DialogTitle>
        <DialogContent sx={{ paddingBottom: "0px !important", overflow: "hidden" }} className="dialog-content" dividers>
          <TableContainer sx={{ maxHeight: "45vh", boxShadow: 0, overflowY: "scroll" }} className='table-border width-fill'>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  {
                    columns?.map((column) => (
                      <TableCell
                        size='small'
                        sx={{ backgroundColor: '#fafafa' }}
                        key={column.id}
                        align={column.align}
                        style={{ minWidth: column.minWidth }}
                      >
                        {column.label}
                      </TableCell>
                    ))
                  }
                </TableRow>
              </TableHead>
              <TableBody>
                {
                  delimiters?.map((delimiter, index) => {
                    return (
                      <TableRow hover key={'delim-' + index} className='dc-row'>
                        <TableCell size="small" className='dc-row'>
                          <Button size='small' variant="outlined" onClick={() => { handleAddButton(delimiter.hex) }}>
                            {t('BTN_ADD')}
                          </Button>
                        </TableCell>
                        <TableCell size="small">
                          {/* used "\xa0" to get extra space */}
                          {`${padNumber(index)}` + ("\xa0").repeat(4) + `${delimiter.display}`}
                        </TableCell>
                        <TableCell size="small">
                          \u00{delimiter.hex}
                        </TableCell>
                      </TableRow>
                    )
                  })
                }
              </TableBody>
            </Table>
          </TableContainer>
          <Stack direction={"row"} spacing={"8px"} className='padding-ver-12'>
            <TextField
              label={t('TAB_DELIMITER')}
              variant='outlined'
              size='small'
              autoFocus={true}
              placeholder=''
              value={delimInput}
              onChange={(e) => handleTextField(e)}
            />
            <Button size='small' onClick={() => handleClear()} variant='outlined'>
              {t('BTN_CLEAR')}
            </Button>
            <Button size='small' onClick={() => handleCRLF(delimInput + 'CRLF')} className={'crlf'} variant='outlined'>
              {t('LBL_CRLF')}
            </Button>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Stack direction={"row"} spacing={"8px"}>
            <Button
              size='small'
              variant="outlined"
              color="primary"
              onClick={() => {
                handleModalAction(true)
                props.handleInput(delimInput.replaceAll('CR', hexToAscii('0D')).replaceAll('LF', hexToAscii('0A')));
              }}
            >
              {t("BTN_OK")}
            </Button>
            <Button
              size='small'
              variant="outlined"
              color="primary"
              onClick={() => handleModalAction(false)}
            >
              {t("BTN_CANCEL")}
            </Button>
          </Stack>

        </DialogActions>
      </Dialog>
    </>
  )
}

export default DelimiterDialog